// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JPG4","toggle":"styles_toggle__1H87e","preview":"styles_preview__15adl"};